const INITIAL_STATE = {
  lista: [],
  lat: 0,
  lng: 0,
  loadUsers: "carregando"
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "getUserPosition":
      return { ...state, lista: action.payload };
    case "location":
      return { ...state, lat: action.payload.lat, lng: action.payload.lng };
    case "loadUsers":
      return { ...state, loadUsers: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/getUserPosition.js